"use strict";

var _Text;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useFleetCompany } from '@autoguru/components/FleetCompanyProvider';
import { Box, Column, Columns, Stack, Text } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { useEffect, useReducer } from 'react';
import HomeQuoteLauncherForm from './HomeQuoteLauncherForm';
import { QuoteLauncherActionType, quoteLauncherReducer } from './reducer';
import * as styles from './HomeQuoteLauncher.css';
import { CDN } from '@autoguru/global-configs';
import { getFromStore, setToStore } from '~/src/helpers/store';
import { useLauncherContext } from '~/src/scenes/Homepage/HomeLauncherVehicleProvider';
import { useFleetQuoteUrl } from '~/src/scenes/Homepage/useFleetQuoteUrl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HomeQuoteLauncher = () => {
  const {
    setMake,
    make: ctxMake,
    setModel,
    model: ctxModel
  } = useLauncherContext();
  const {
    slug,
    id
  } = useFleetCompany();
  const [{
    make,
    model,
    location
  }, dispatch] = useReducer(quoteLauncherReducer, {
    make: ctxMake,
    model: ctxModel,
    location: getFromStore('homepage-location')
  });
  useEffect(() => {
    if (make && (!ctxMake || make.slug !== ctxMake.slug)) {
      setMake(make);
    }
  }, [make, ctxMake, setMake]);
  useEffect(() => {
    if (model && (!ctxModel || model.slug !== ctxModel.slug)) {
      setModel(model);
    }
  }, [model, ctxModel, setModel]);
  const linkUrl = useFleetQuoteUrl({
    make,
    model,
    location,
    id
  });
  const makeChanged = value => dispatch({
    type: QuoteLauncherActionType.MAKE_CHANGED,
    value
  });
  const modelChanged = value => dispatch({
    type: QuoteLauncherActionType.MODEL_CHANGED,
    value
  });
  const suburbChanged = value => {
    setToStore('homepage-location', value);
    dispatch({
      type: QuoteLauncherActionType.LOCATION_CHANGED,
      value
    });
  };
  const handleSubmit = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!linkUrl) return;
    window.open(linkUrl, '_self');
  };
  return /*#__PURE__*/_jsx(Box, {
    width: "full",
    padding: "5",
    backgroundColour: "white",
    boxShadow: "none",
    borderWidth: "1",
    borderColour: "light",
    children: /*#__PURE__*/_jsxs(Stack, {
      space: "5",
      children: [/*#__PURE__*/_jsxs(Columns, {
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Column, {
          grow: true,
          width: "auto",
          alignSelf: "centre",
          children: /*#__PURE__*/_jsx(Picture, {
            backgroundColor: "transparent",
            width: "auto",
            height: 32,
            aspectRatio: 0.2,
            altText: "",
            src: `${CDN}/images/fleet-providers/${slug}/logo-wide.svg`
          })
        }), /*#__PURE__*/_jsx(Column, {
          noShrink: true,
          alignSelf: "centre",
          children: /*#__PURE__*/_jsx(Picture, {
            backgroundColor: "transparent",
            width: "auto",
            height: 52,
            aspectRatio: 1.6,
            altText: "",
            src: `${CDN}/images/fleet-providers/${slug}/pay-card.webp`,
            fallbackSrc: `${CDN}/images/fleet-providers/${slug}/pay-card.png`
          })
        })]
      }), _Text || (_Text = /*#__PURE__*/_jsx(Text, {
        strong: true,
        as: "p",
        size: "5",
        colour: "neutral",
        children: "Get quotes from local service providers."
      })), /*#__PURE__*/_jsx(HomeQuoteLauncherForm, {
        className: styles.form,
        location: location,
        model: model,
        make: make,
        suburbChanged: suburbChanged,
        makeChanged: makeChanged,
        modelChanged: modelChanged,
        handleSubmit: handleSubmit
      })]
    })
  });
};